/**
 * Plain object Packlink's API response representation.
 *
 */

/**
 * Customs cost API representation
 */

/**
 * Payload used in POST and PUT endpoints
 *
 */

class CustomsInventoryItemMapper {
  /**
   * Takes a ICustomsInvoiceApiResponse from Packlink's API and returns a CustomsInvoice.
   *
   * @param response  ICustomsInvoiceApiResponse response from Packlink's API.
   *
   */

  static createModelFromResponse(response) {
    var _response$item_value;
    if (!response) {
      return undefined;
    }
    return {
      tariffNumber: response.tariff_number,
      description: response.description,
      countryOfOrigin: response.country_of_origin,
      value: (_response$item_value = response.item_value) === null || _response$item_value === void 0 ? void 0 : _response$item_value.value,
      weight: response.item_weight,
      quantity: response.quantity
    };
  }
  static createApiPayload(customsInventoryItem, currency) {
    return {
      tariff_number: customsInventoryItem.tariffNumber,
      description: customsInventoryItem.description,
      country_of_origin: customsInventoryItem.countryOfOrigin,
      item_value: customsInventoryItem.value ? {
        value: customsInventoryItem.value,
        currency
      } : undefined,
      item_weight: customsInventoryItem.weight,
      quantity: customsInventoryItem.quantity
    };
  }
}

export { CustomsInventoryItemMapper };
//# sourceMappingURL=CustomsInventoryItemMapper.js.map
